import React from 'react';

import {PortfolioUtils} from '../../../../../../../utils/utils';
import _ from 'lodash';
import ChartSectionBordered from "../../../../../components_v2/ChartSectionBordered/ChartSectionBordered";
import {StructureTable} from "../../../../../components_v2/StructureTable/StructureTable";
import {
  CustomerDashboardNoDataPlaceholder
} from "../../../../../../FactSheetsPage/components/NoDataPlaceholder";
import {portfolioStructurePropsAreEquals} from '../utils';

const PortfolioMorningstarCategoryStructure = React.memo((props) => {
  const {
    dashboardData,
    preferredColor,
    expanded,
    onExpanded,
  } = props;

  const portfolioStructure = dashboardData && dashboardData.portfolio_structure;

  let data = [];
  if (portfolioStructure) {
    data = PortfolioUtils.getPortfolioMorningstarCategories(portfolioStructure)
  }
  const hasData = !_.isEmpty(data);

  return (
    <ChartSectionBordered
      title={<b>{data.length !== 1 ? 'Morningstar-Kategorien' : 'Morningstar-Kategorie'}</b>}
      expanded={expanded}
      onExpanded={onExpanded}
      skipContentPadding={hasData}
      content={(
        <>
          {hasData ? (
            <StructureTable
              series={data || []}
              preferredColor={preferredColor}
            />
          ) : (
            <CustomerDashboardNoDataPlaceholder />
          )}
        </>
      )}
    />
  )
}, portfolioStructurePropsAreEquals);

export default PortfolioMorningstarCategoryStructure;
